/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-autofocus */
import React, { useCallback, useEffect, useState } from "react"
import { Link, useParams } from "react-router-dom"
import { toast } from "react-toastify"
import { getOrganisationDetail } from "../../requesters/Backend/OrganisationRequester"
import { changeUnitState } from "../../requesters/Backend/UnitRequester"
import UpdateOrgPage from "./UpdateOrgPage"

function OrgDetailPage({ baseUrl, currentUser }) {
  const { organisationId } = useParams()
  const [organisationDetail, setOrganisationDetail] = useState({})
  const [editable, setEditable] = useState(false)

  const fetchOrganisationDetail = useCallback(() => {
    getOrganisationDetail(baseUrl, organisationId, currentUser).then(res => {
      setOrganisationDetail(res.response.json.organisation)
      return null
    })
  }, [baseUrl, currentUser, organisationId])

  useEffect(() => {
    fetchOrganisationDetail()
  }, [fetchOrganisationDetail])

  const onChangeEditable = () => {
    setEditable(!editable)
  }

  const onChangeArchived = e => {
    const newStatus = e.target.checked ? "Active" : "Inactive"
    changeUnitState(baseUrl, e.target.name, currentUser).then(res => {
      if (res.status === 201) {
        toast.success(`Unit Status successfully updated to: ${newStatus}`)
      } else {
        toast.error(`Unit Status not updated`)
      }
    }).catch(err => {
      toast.error(`${err}`)
    })
  }

  if (editable) {
    return (
      <UpdateOrgPage
        baseUrl={baseUrl}
        currentUser={currentUser}
        fetchOrganisationDetail={fetchOrganisationDetail}
        onChangeEditable={onChangeEditable}
        organisationDetail={organisationDetail} />
    )
  }

  return (
    <div className="content">
      <div className="container-fluid">
        <div className="form-container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/backend">Organisation</Link>
              </li>
              <li aria-current="page" className="breadcrumb-item active">{organisationDetail.name}</li>
            </ol>
          </nav>
          <h1>{organisationDetail.name}</h1>
          <div className="my-4">
            <div className="btn btn-outline-main btn-sm">More </div>
          </div>
          <div className="card-section">
            <div className="card">
              <div className="card-header"><h5>Units</h5></div>
              <div className="card-body">
                <table className="table">
                  <tbody>
                    {organisationDetail.units && organisationDetail.units.map((unit, index) => (
                      <tr key={unit.id}>
                        <td>
                          <Link to={`/backend/units/${unit.id}`}>{unit.name}</Link>
                        </td>
                        <td className="text-right">
                          <div className="custom-control custom-switch">
                            <input
                              onChange={onChangeArchived}
                              defaultChecked={unit.status === "active"}
                              className="custom-control-input"
                              name={unit.id}
                              id={`customSwitch${index}`}
                              type="checkbox" />
                            <label className="custom-control-label" htmlFor={`customSwitch${index}`}>
                              <span className="sr-only">
                                Toggle archived status for
                                {unit.name}
                              </span>
                            </label>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <button type="button" className="btn btn-outline-main btn-sm" onClick={onChangeEditable}>+ Add Unit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrgDetailPage
